module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorMessage":"Error while loading. Reload page is required."},"zh":{"errorMessage":"加载时出错。 需要重新加载页面。"},"kr":{"errorMessage":"로드하는 동안 오류가 발생했습니다. 페이지를 새로 고침해야합니다."}}')
  delete Component.options._Ctor
}
